import React from "react";

import { styles } from "@common/styles";
import { Input } from "@components";
require("../../common/styles/style.css");

export interface IResetPasswordActions {
  navigateToLogin: () => void;
  resetPassword: (username: string) => void;
}

export interface IResetPasswordState {
  username: string;
}

class ResetPassword extends React.Component<
  IResetPasswordActions,
  IResetPasswordState
> {
  constructor(props) {
    super(props);

    this.state = {
      username: ""
    };
  }

  public render() {
    const cancelButtonStyle = {
      ...styles.okButton,
      ":hover": { backgroundColor: "#555", textDecoration: "underline" },
      backgroundColor: "#444"
    };

    return (
      <div>
        <div className="logoContainer" style={styles.logoContainer as any}>
          <img src="/images/logo.png" />
        </div>
        <div className="headerContainer" style={styles.headerContainer as any}>
          Glemt passord?
        </div>
        <div className="container" style={styles.container as any}>
          <div className="textContainer" style={styles.textContainer as any}>
            Skriv inn ditt brukernavn for å få tilsendt et nytt passord.
          </div>
          <Input
            name="username"
            label="Brukernavn"
            value={this.state.username}
            type="text"
            onChange={username => this.setState({ username })}
          />
          <div className="buttonContainer" style={styles.buttonContainer}>
            <div style={styles.sendButtonContainer as any}>
              <button
                className="okButton"
                ref="okButton"
                style={styles.okButton as any}
                onClick={() => this.props.resetPassword(this.state.username)}
              >
                Send nytt passord
              </button>
            </div>
            <div style={styles.goBackButtonContainer as any}>
              <button
                className="cancelButton"
                ref="navButton"
                style={cancelButtonStyle as any}
                onClick={this.props.navigateToLogin}
              >
                Gå tilbake
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPassword;
